// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ContactInfoType } from './contactInfoType.js';
import type { SimpleIntakeContactPhonesModel } from './simpleIntakeContactPhonesModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SimpleIntakeContactModel {
    'email'?: string;
    'firstName'?: string;
    'job'?: string;
    'lastName'?: string;
    'note'?: string;
    'phones'?: SimpleIntakeContactPhonesModel | null;
    'preferred'?: ContactInfoType;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SimpleIntakeContactModel>> = [
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "job",
            "baseName": "job",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "note",
            "baseName": "note",
            "type":     "string"
        },
        {
            "name":     "phones",
            "baseName": "phones",
            "type":     "SimpleIntakeContactPhonesModel"
        },
        {
            "name":     "preferred",
            "baseName": "preferred",
            "type":     "ContactInfoType"
        },
    ];

    static getAttributeTypeMap() {
        return SimpleIntakeContactModel.attributeTypeMap;
    }
}
